import {
  profileSettingsSchema,
  ProfileSettingsSchema,
} from '@soniq/schema-connection'
import {
  HttpReadWriteStore,
  ProjectionEntityStore,
} from '@soniq/public-resource'

export class ProfileSettingsHttpStore extends HttpReadWriteStore<ProfileSettingsSchema> {
  static new() {
    return new ProfileSettingsHttpStore(
      'profile_settings',
      profileSettingsSchema.validateFn
    )
  }
}

export class ProfileSettingsProjectionStore extends ProjectionEntityStore<ProfileSettingsSchema> {
  static new() {
    return new ProfileSettingsProjectionStore(
      'profile_settings',
      profileSettingsSchema
    )
  }
}
